import { CASH } from '@makemydeal/dr-platform-types';
import { getDealXgDetailsState } from './dealXgDetailsSelectors';
import type { LockCreditRatingAndTermsByDealType, OfferTypeMode } from '@makemydeal/dr-shared-types';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import * as offerReduxSelectors from './offerRedux';

/**
 * Gets the lock payment inputs state in Sales View
 * Returns LockCreditRatingAndTermsByDealType
 * @param state - Redux state
 * @returns LockCreditRatingAndTermsByDealType
 */
export function getLockPaymentInputsInSV(state: any): LockCreditRatingAndTermsByDealType {
    const dealXgDetails = getDealXgDetailsState(state);
    return dealXgDetails.lockCreditRatingAndTermsByDealType || {};
}

/**
 * Gets the lock payment status if it's possible to lock the deal
 * Returns boolean
 * @param state - Redux state
 * @returns boolean
 */
export function isLockSupported(state: any) {
    const isMvLiteEnabled = dealerSelectors.isMvLiteEnabled(state);
    const isFlexBuyPayment = offerReduxSelectors.isFlexBuyPayment(state);
    const offerType = offerReduxSelectors.getCurrentOfferType(state);
    return offerType !== CASH && !isFlexBuyPayment && !isMvLiteEnabled;
}

/**
 * Gets the lock payment inputs state for a specific deal type in Sales View
 * Returns whether the payment inputs (credit rating, term months, mileage) are locked
 * @param state - Redux state
 * @returns true if payment inputs are locked for the specified deal type, false otherwise
 */
export function getLockPaymentInputsInSVByDealType(state: any): boolean {
    const isSupported = isLockSupported(state);
    if (!isSupported) return false;
    const dealTypeKey = offerReduxSelectors.getCurrentOfferType(state) as OfferTypeMode;
    const lockCreditRatingAndTermsByDealType = getLockPaymentInputsInSV(state);
    return lockCreditRatingAndTermsByDealType[dealTypeKey] ?? false;
}
